// extracted by mini-css-extract-plugin
export default {"StyledRadio":"StyledRadio_StyledRadio__lzmJX","StyledRadio-label":"StyledRadio_StyledRadio-label__k+o6A"};